var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"changed-item clearfix"},[_c('not-can-edit',{staticClass:"fl",attrs:{"data":_vm.data}}),_c('a-button',{attrs:{"type":"default"},on:{"click":_vm.handleDelete}},[_vm._v("\n    "+_vm._s(_vm.$t('message["962"]'))+"\n  ")]),_c('span',{staticClass:"fs-warning fl tip"},[_vm._v(_vm._s(_vm.$t('message["332"]')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }